import React, { useState, FC } from 'react';
import { InputFieldWrapper } from '@components-shared/forms/FieldLabel';
import { Slider } from 'antd';
import cn from 'classnames';
import NumericInput from '../NumberInput/NumericInput';
import { IProps } from '../NumberInput/numberInput';
import styles from './styles.module.scss';

interface InputWithSliderProps extends IProps {
  step?: number;
  minValue?: number;
  maxValue?: number;
  defaultValue?: number;
  wrapperClassName?: string;
}

export const InputWithSlider: FC<InputWithSliderProps> = (props) => {
  const {
    minValue = 0,
    maxValue = 100,
    step = 1,
    value,
    onChange,
    attributes,
    name,
    wrapperClassName,
    className,
    title,
    required,
    valid,
    validationMessage,
    hintMessage,
    precision = 0,
    hideNumericArrows = true,
    tooltip,
  } = props;

  const disabled = attributes?.disabled;
  const inputValue = +value;

  const [previousValue, setPreviousValue] = useState<number>(inputValue);

  const onInputChange = (name: string, value: string | number) => {
    const numericValue = +value;

    if (numericValue > maxValue) {
      setPreviousValue(previousValue);

      return;
    }

    onChange(name, String(numericValue));

    setPreviousValue(numericValue);
  };

  const onSliderInputChange = (value: number) => {
    setPreviousValue(value);

    onInputChange(name, value);
  };

  const renderInput = () => {
    return (
      <div className={styles.inputWithSlider__inputWrapper}>
        <NumericInput
          className={cn('form__input', { invalid: !valid })}
          name={name}
          step={step}
          allowNegativeValues={false}
          disabled={disabled}
          hideNumericArrows={hideNumericArrows}
          value={value}
          precision={precision}
          onChange={(value) => onInputChange(name, value)}
        />
      </div>
    );
  };

  const renderSlider = () => {
    return (
      <div className={styles.inputWithSlider__wrapper}>
        <div className={styles.inputWithSlider__sliderLabels}>
          <p className={styles.inputWithSlider__sliderLabel}>{minValue}%</p>
          <p className={styles.inputWithSlider__sliderLabel}>{maxValue}%</p>
        </div>
        <Slider
          min={minValue}
          max={maxValue}
          step={step}
          onChange={onSliderInputChange}
          value={inputValue}
          tooltip={{ open: false }}
          className={styles.inputWithSlider__slider}
          disabled={disabled}
        />
      </div>
    );
  };

  return (
    <InputFieldWrapper
      name={name}
      title={title}
      tooltip={tooltip}
      required={required}
      className={className}
      valid={valid}
      validationMessage={validationMessage}
      hintMessage={hintMessage}>
      <div className="form__input-wrapper">
        <div className={`${styles.inputWithSlider} ${wrapperClassName ?? ''}`}>
          {renderInput()}
          {renderSlider()}
        </div>
      </div>
    </InputFieldWrapper>
  );
};
